import React, { useState } from "react";
import DetailsModal from "../DetailsModal/DetailsModal";
import "./style.css";

const ReceivedDocumentsList = () => {
  const [modal, setModal] = useState(false);

  const openModal = () => {
    setModal(true);
  };
  return (
    <div>
      {modal && <DetailsModal />}
      <div className="title_section">
        <div>
          <h4 className="title">Receiving Office</h4>
          <p className="inner_title">
            Documents to Receive WITHOUT TRACKING NUMBER
          </p>
        </div>
        <div>
          <ul>
            <li className="nav_items">
              <i className="fas fa-home-alt"></i>Home
            </li>
            <li className="nav_items">Dashboard</li>
            <li className="nav_items">22:22:23</li>
          </ul>
        </div>
      </div>
      <div className="table-wrapper">
        <p className="title">FOR RECEIVING</p>
        <div className="action_form">
          <div className="show">
            <p>Show</p>
            <select>
              <option>10</option>
              <option>20</option>
              <option>30</option>
              <option>40</option>
            </select>
            <p>entries</p>
          </div>
          <div className="search">
            <p>Search:</p>
            <input type="text" />
          </div>
        </div>
      </div>
      <div className="table-wrapper">
        <table>
          <tr>
            <th>Type</th>
            <th>Details</th>
            <th>From</th>
            <th>Office</th>
            <th>ACTION NEEDED</th>
            <th>Date & Time Posted</th>
            <th>Action</th>
          </tr>
          <tr>
            <td>Application Documents</td>
            <td>
              <div>
                <p>Topography Report</p>
                <a style={{ textDecoration: "none" }} href="https://google.com">
                  File
                </a>
              </div>
              <div>
                <p>Topography Report</p>
                <a style={{ textDecoration: "none" }} href="https://google.com">
                  File
                </a>
              </div>
            </td>
            <td>
              <div>
                <p>GUEST</p>
                <p>Prakash Shrestha</p>
              </div>
            </td>
            <td>
              <p>Bigo information Technology</p>
            </td>
            <td>
              <p>Standing list for Bidding</p>
            </td>
            <td>
              <p>07/03/22 @ 10:15 PM</p>
            </td>
            <td>
              <div>
                <button className="view_btn">view</button>
                <button className="receive_btn">Receive</button>
              </div>
            </td>
          </tr>
          <tr>
            <td>Application Documents</td>
            <td>
              <div>
                <p>Topography Report</p>
                <a style={{ textDecoration: "none" }} href="https://google.com">
                  File
                </a>
              </div>
              <div>
                <p>Topography Report</p>
                <a style={{ textDecoration: "none" }} href="https://google.com">
                  File
                </a>
              </div>
            </td>
            <td>
              <div>
                <p>GUEST</p>
                <p>Prakash Shrestha</p>
              </div>
            </td>
            <td>
              <p>Bigo information Technology</p>
            </td>
            <td>
              <p>Standing list for Bidding</p>
            </td>
            <td>
              <p>07/03/22 @ 10:15 PM</p>
            </td>
            <td>
              <div>
                <button onClick={openModal} className="view_btn">
                  view
                </button>
                <button className="receive_btn">Receive</button>
              </div>
            </td>
          </tr>
          <tr>
            <td>Application Documents</td>
            <td>
              <div>
                <p>Topography Report</p>
                <a style={{ textDecoration: "none" }} href="https://google.com">
                  File
                </a>
              </div>
              <div>
                <p>Topography Report</p>
                <a style={{ textDecoration: "none" }} href="https://google.com">
                  File
                </a>
              </div>
            </td>
            <td>
              <div>
                <p>GUEST</p>
                <p>Prakash Shrestha</p>
              </div>
            </td>
            <td>
              <p>Bigo information Technology</p>
            </td>
            <td>
              <p>Standing list for Bidding</p>
            </td>
            <td>
              <p>07/03/22 @ 10:15 PM</p>
            </td>
            <td>
              <div>
                <button className="view_btn">view</button>
                <button className="receive_btn">Receive</button>
              </div>
            </td>
          </tr>
          <tr>
            <td>Application Documents</td>
            <td>
              <div>
                <p>Topography Report</p>
                <a style={{ textDecoration: "none" }} href="https://google.com">
                  File
                </a>
              </div>
              <div>
                <p>Topography Report</p>
                <a style={{ textDecoration: "none" }} href="https://google.com">
                  File
                </a>
              </div>
            </td>
            <td>
              <div>
                <p>GUEST</p>
                <p>Prakash Shrestha</p>
              </div>
            </td>
            <td>
              <p>Bigo information Technology</p>
            </td>
            <td>
              <p>Standing list for Bidding</p>
            </td>
            <td>
              <p>07/03/22 @ 10:15 PM</p>
            </td>
            <td>
              <div>
                <button className="view_btn">view</button>
                <button className="receive_btn">Receive</button>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div className="table_footer">
        <div>
          <p>Showing 1 to 1 of 1 entries</p>
        </div>
        <div>
          <button>Previous</button>
          <button
            style={{
              backgroundColor: "#1976d2",
              color: "white",
              border: "none",
              padding: "3px 10px",
            }}
          >
            1
          </button>
          <button>Next</button>
        </div>
      </div>
    </div>
  );
};

export default ReceivedDocumentsList;
